import { FLOW_CONTEXT_TYPES, ModalType, openFipMigrationModal } from '@fiverr-private/pro_migration';
import { isMigrationRequired, isSignUpRequired } from '../../utils/isSignUpOrMigrationRequired';

interface ExtendedWindow extends Window {
    openSignUpModal?: (
        modalOptions: {
            redirectUrl?: string;
            triggerType?: string;
            triggerCopy?: string;
            triggerPlacement?: string;
        },
        biEnrichment: { source: string }
    ) => void;
}

declare const window: ExtendedWindow;

const safeWindow = typeof window !== 'undefined' ? window : undefined;

const MIGRATION_TRIGGER = 'save_to_list';

interface requireSignInProps {
    pageName: string;
    onSuccess: () => void;
    triggerData: {
        triggerType?: string;
        triggerCopy?: string;
        triggerPlacement?: string;
    };
}

export const requireSignIn = ({ pageName = 'collect_actions', onSuccess, triggerData = {} }: requireSignInProps) => {
    if (isSignUpRequired()) {
        safeWindow?.openSignUpModal?.(
            {
                ...triggerData,
            },
            { source: pageName }
        );
        return;
    }

    if (isMigrationRequired()) {
        openFipMigrationModal({
            variant: ModalType.FullMigration,
            payload: {
                source: `${pageName}.${MIGRATION_TRIGGER}`,
                withSkipAction: false,
                biEnrichment: {
                    pageElementName: pageName,
                    trigger: MIGRATION_TRIGGER,
                },
                flowContext: {
                    type: 'save_expert' as FLOW_CONTEXT_TYPES,
                },
            },
        });
        return;
    }

    onSuccess();
};
